import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useTranslation } from "react-i18next";
import { Fragment } from "react";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgb(125, 217, 255)",
    color: "rgb(59, 59, 59)",
    fontWeight: "bold",
    border: "2px solid rgb(234, 234, 234)",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    border: "2px solid rgb(234, 234, 234)",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  // "&:nth-of-type(odd)": {
  //   backgroundColor: theme.palette.action.hover,
  // },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
    backgroundColor: "rgb(245, 245, 245)",
  },
}));

export interface ITableProps {
  headerData: string[];
  rowsData: (string | (string | number)[][])[][];
}

export default function CustomizedTables({
  headerData,
  rowsData,
}: ITableProps) {
  const { i18n } = useTranslation();
  return (
    <TableContainer
      component={Paper}
      sx={{
        "@media print": {
          breakInside: "auto",
          colorAdjust: "exact",
        },
      }}
    >
      <Table sx={{ minWidth: 700 }} aria-label="Teacher Assignment">
        <TableHead>
          <TableRow>
            {headerData.map((head, index) => (
              <StyledTableCell
                align={
                  index !== 0
                    ? "center"
                    : i18n.dir() === "rtl"
                    ? "right"
                    : "left"
                }
                key={"head" + index}
              >
                {head}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rowsData.map((rowGroup, index) => (
            <Fragment key={"RowGroup" + index}>
              <StyledTableRow key={"rowGroup" + index + "cell0"}>
                <StyledTableCell
                  component="th"
                  align={i18n.dir() === "rtl" ? "right" : "left"}
                  scope="row"
                  key={"cell0-row" + index}
                  rowSpan={rowGroup[1].length + 1}
                >
                  {rowGroup[0]}
                </StyledTableCell>
              </StyledTableRow>
              {(rowGroup[1] as (string | number)[][]).map((row, rowIndex) => (
                <StyledTableRow key={"row" + rowIndex}>
                  {row.map((cell, cellIndex) => (
                    <StyledTableCell
                      align="center"
                      scope="row"
                      key={
                        "cell" + cellIndex + "row" + rowIndex + "group" + index
                      }
                    >
                      {cell}
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              ))}
            </Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
